module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_1.ff2f8bbc.gif";